import { useState } from "react";
import { IGroupRequest } from "../../../../../@types/group.type";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";

import styles from "./styles.module.scss";
import React from "react";
import { ButtonDeleted } from "../../../../../components/ButtonDeleted";
import arrowIconBottom from "./../../../../../assets/_ArrowIconBottom_.svg";
import closeIconModal from "./../../../../../assets/_CloseIconModal_.svg";
import { useConfirm } from "../../../../../hooks/useConfirm";
import { Button as ButtonCustom } from "../../../../../components/Button";
import addCircleImage from "./../../../../../assets/_AddCircleIcon_.svg";
import { SelectGroupModal } from "../ModalSelectGroup";

interface UserProps {
    groups: IGroupRequest[]
    setGroups: React.Dispatch<
    React.SetStateAction<IGroupRequest[] | []>>;
}

export const GroupList: React.FC<UserProps> = ({groups, setGroups}) => {
    const [showAll, setShowAll] = useState(false);
    const [reload, setReload] = useState(false);
    const displayedGroups = showAll ? groups : groups.slice(0, 3);
    
    const [openModalGroup, setOpenModalGroup] = useState(false);
    const handleOpenModalGroup = () => setOpenModalGroup(true);
    const handleCloseModalGroup = () => setOpenModalGroup(false);

    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const handleOpenModalConfirm = () => setOpenModalConfirm(true);
    const handleCloseModalConfirm = () => setOpenModalConfirm(false);

    const { showConfirm, Confirm } = useConfirm(
        "Tem certeza que deseja excluir o usuário desse grupo?",
        openModalConfirm,
        handleCloseModalConfirm,
        "Isso vai excluir todas permissões desse grupo para esse usuário."
    );

    const handleDeleteGroup = async (groupId: string) => {
        handleOpenModalConfirm();
        try {
          const isConfirm = await showConfirm();
          if (isConfirm) {
            setGroups((prevGroups) => prevGroups.filter((group) => group.groupId !== groupId));
            setReload((prev) => !prev);
          }
        } catch (error) {
          console.error("Erro ao deletar:", error);
        }
      };

    return (
        <>
        <div className={styles.headerContainer}>
          <h3 className={styles.title}>Grupos de Permissões</h3>
          <div>
              <ButtonCustom
                iconUrl={addCircleImage}
                onClick={handleOpenModalGroup}
                content="Adicionar Grupo"
                className={styles.newUserButton}
                type="button"
              />
          </div>
        </div>
        <List className={styles.listContainer}>
        {groups.length === 0 ? (
            <ListItem alignItems="center" className={styles.listItem}>
                <ListItemText
                    className={styles.listItemText}
                    primary={
                        <span className={styles.primaryText}>
                        Esse usuário não pertence a nenhum grupo de permissões
                        </span>
                    }
                    secondary={
                        <span className={styles.secondaryText}>
                        É possível adicionar grupos no botão acima
                        </span>
                    }
                    style={{ textAlign: "center" }}
                />
          </ListItem>
        ) : (
            displayedGroups.map((group, index) => (
            <React.Fragment key={group.groupId}>
              <ListItem alignItems="center" className={styles.listItem}>
                <ListItemText
                  className={styles.listItemText}
                  primary={
                    <span className={styles.primaryText}>{group.groupName}</span>
                  }
                />
                <div>
                  <ButtonDeleted
                    handleDeleteItem={() => handleDeleteGroup(group.groupId)}
                  />
                </div>
              </ListItem>
              {groups.length > 3 ? (
                  <Divider variant="middle" component="li" className={styles.divider} />
                ) : (
                  index < displayedGroups.length - 1 && (
                    <Divider variant="middle" component="li" className={styles.divider} />
                  )
              )}
            </React.Fragment>
          ))
        )}
        {groups.length > 3  &&
          displayedGroups.every((group) => group.groupId !== undefined) && (
            <ListItem
              style={{ justifyContent: "center" }}
              className={styles.listItemSeeMore}
            >
              <Button
                onClick={handleOpenModal}
                variant="text"
                color="primary"
                sx={{ textTransform: "none", padding: "10px 8px" }}
                className={styles.buttonSeeMore}
              >
                <div>Ver Mais</div>
                {arrowIconBottom && (
                  <img src={arrowIconBottom} style={{ marginLeft: "8px" }} />
                )}
              </Button>
            </ListItem>
          )}
      </List>

      <Modal open={openModal} onClose={handleCloseModal}>
        <div className={styles.modal}>
          <div className={styles.header}>
            <h3>Lista de Grupos de Permissões</h3>
            <Button onClick={handleCloseModal} className={styles.iconButton}>
              {closeIconModal && <img src={closeIconModal} />}
            </Button>
          </div>
          <List className={styles.listContainerModal}>
            {groups.map((group) => (
              <React.Fragment key={group.groupId}>
                <ListItem alignItems="center" className={styles.listItemModal}>
                  <ListItemText
                    className={styles.listItemText}
                    primary={
                      <span className={styles.primaryText}>{group.groupName}</span>
                    }
                  />
                  <ButtonDeleted
                    handleDeleteItem={() => handleDeleteGroup(group.groupId)}
                  />
                </ListItem>
                <Divider
                  variant="middle"
                  component="li"
                  className={styles.divider}
                />
              </React.Fragment>
            ))}
          </List>
        </div>
      </Modal>

      <SelectGroupModal
        open={openModalGroup}
        onClose={handleCloseModalGroup}
        groups={groups}
        setGroups={setGroups}
      />

      {Confirm}
      </>
    );
}